mutation ApprovalTestGroupCreate($input: ApprovalTestGroupCreateInput!) {
  approvalTestGroupCreate(input: $input) {
    query {
      approvalTestGroups(orderBy: NAME_ASC) {
        nodes {
          id
          _rowTimestamp
          name
          description
          approvalTestItems {
            nodes {
              id
            }
          }
        }
        totalCount
      }
    }
  }
}
